import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Card,
    CardContent,
    Typography,
    Paper,
    Stack,
    Chip,
    Avatar,
    MenuItem
} from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PersonIcon from "@mui/icons-material/Person";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { getMensajesTablon, postMensajeTablon } from "../../services/apis";

const formatearFecha = (valor) => {
    if (!valor) return "Sense data";
    return new Date(valor).toLocaleString("ca-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const inicialUsuario = (nombre = "") => {
    return nombre.trim().charAt(0).toUpperCase() || "?";
};

export const TablonAnuncios = () => {
    const [comentarios, setComentarios] = useState([]);
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear());
    const [aniosDisponibles, setAniosDisponibles] = useState([new Date().getFullYear()]);
    const [nuevoComentario, setNuevoComentario] = useState("");
    const [fecha, setFecha] = useState(() => new Date().toISOString().split("T")[0]);
    const [hora, setHora] = useState(() => new Date().toLocaleTimeString("ca-ES", { hour12: false, hour: "2-digit", minute: "2-digit" }));

    const cargarMensajes = async () => {
        try {
            const response = await getMensajesTablon(anioSeleccionado);
            if (response && response.data && Array.isArray(response.data.data)) {
                const adaptados = response.data.data.map((item) => ({
                    id: item.idAnuncio,
                    usuario: item.nombreUsuario,
                    mensaje: item.mensaje,
                    fechaCreacion: item.fechahora,
                    fechaMostrar: item.fechaMostrar,
                }));
                setComentarios(adaptados);
                setAniosDisponibles(response.data.years?.length ? response.data.years : [new Date().getFullYear()]);
            }
        } catch (error) {
            setComentarios([]);
        }
    };

    useEffect(() => {
        cargarMensajes();
    }, [anioSeleccionado]);

    const handleAddComentario = async () => {
        if (!nuevoComentario.trim()) return;

        const now = new Date();
        const fechaCreacion = now.toISOString().split("T")[0];
        const horaCreacion = now.toLocaleTimeString("ca-ES", { hour12: false });
        const fechaFinal = fecha || fechaCreacion;
        const horaFinal = hora || "00:00:00";

        const data = {
            mensaje: nuevoComentario,
            fechahora: `${fechaCreacion} ${horaCreacion}`,
            fechaMostrar: `${fechaFinal} ${horaFinal}`,
        };

        try {
            const response = await postMensajeTablon(data);
            if (response && response.success) {
                setNuevoComentario("");
                setFecha("");
                setHora("");
                cargarMensajes();
            } else {
                console.error("Error en publicar l'anunci:", response);
            }
        } catch (error) {
            console.error("Error en la petició:", error);
        }
    };

    const comentariosOrdenados = [...comentarios].sort(
        (a, b) => new Date(b.fechaMostrar || b.fechaCreacion) - new Date(a.fechaMostrar || a.fechaCreacion)
    );

    const esActivo = (fechaMostrar) => {
        if (!fechaMostrar) return false;
        const fechaMsg = new Date(fechaMostrar);
        const hace30min = Date.now() - 30 * 60 * 1000;
        return fechaMsg.getTime() >= hace30min && fechaMsg.getTime() <= Date.now();
    };

    const totalActivos = comentariosOrdenados.filter((item) => esActivo(item.fechaMostrar || item.fechaCreacion)).length;

    return (
        <Box className="board-shell">
            <Paper elevation={0} className="board-header">
                <Box className="board-header-copy">
                    <Typography className="board-eyebrow">
                        Tauler
                    </Typography>
                    <Typography variant="h4" className="board-title">
                        Tauler d'anuncis
                    </Typography>
                </Box>
                <Stack direction="row" className="board-stats">
                    <TextField
                        select
                        label="Any"
                        size="small"
                        value={anioSeleccionado}
                        onChange={(event) => setAnioSeleccionado(Number(event.target.value))}
                        className="board-year-select"
                    >
                        {aniosDisponibles.map((anio) => (
                            <MenuItem key={anio} value={anio}>
                                {anio}
                            </MenuItem>
                        ))}
                    </TextField>
                    <Chip icon={<CampaignIcon />} label={`${comentarios.length} anuncis`} className="board-stat-chip" />
                    {/* <Chip icon={<FiberManualRecordIcon />} label={`${totalActivos} actius`} className="board-stat-chip board-stat-active" /> */}
                </Stack>
            </Paper>

            <Grid container spacing={2} className="board-layout">
                <Grid size={{ xs: 12, md: 4 }}>
                    <Paper elevation={0} className="board-composer">
                        <Box className="board-composer-title">
                            <AddCommentIcon />
                            <Typography variant="h6">
                                Nou anunci
                            </Typography>
                        </Box>
                        <TextField
                            fullWidth
                            multiline
                            minRows={4}
                            placeholder="Escriu un anunci per al grup..."
                            value={nuevoComentario}
                            onChange={(e) => setNuevoComentario(e.target.value)}
                        />

                        <Box className="board-schedule">
                            <TextField
                                type="date"
                                label="Data de publicació"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={fecha}
                                onChange={(e) => setFecha(e.target.value)}
                                fullWidth
                            />
                            <TextField
                                type="time"
                                label="Hora"
                                InputLabelProps={{ shrink: true }}
                                value={hora}
                                onChange={(e) => setHora(e.target.value)}
                                fullWidth
                            />
                        </Box>

                        <Button
                            variant="contained"
                            startIcon={<CampaignIcon />}
                            onClick={handleAddComentario}
                            fullWidth
                        >
                            Publicar
                        </Button>
                    </Paper>
                </Grid>

                <Grid size={{ xs: 12, md: 8 }}>
                    <Stack className="board-feed">
                        {comentariosOrdenados.map((mensaje) => {
                            const activo = esActivo(mensaje.fechaMostrar || mensaje.fechaCreacion);
                            return (
                                <Card key={mensaje.id} className={`board-card ${activo ? "board-card-active" : ""}`} elevation={0}>
                                    <CardContent className="board-card-content">
                                        <Box className="board-card-meta">
                                            <Avatar className="board-avatar">
                                                {inicialUsuario(mensaje.usuario)}
                                            </Avatar>
                                            <Box className="board-card-author">
                                                <Typography className="board-author-name">
                                                    {mensaje.usuario}
                                                </Typography>
                                                <Typography className="board-date">
                                                    <ScheduleIcon fontSize="inherit" />
                                                    {formatearFecha(mensaje.fechaMostrar || mensaje.fechaCreacion)}
                                                </Typography>
                                            </Box>
                                            {activo && (
                                                <Chip size="small" label="Actiu" className="board-active-chip" />
                                            )}
                                        </Box>
                                        <Typography className="board-message">
                                            {mensaje.mensaje}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            );
                        })}

                        {comentariosOrdenados.length === 0 && (
                            <Paper elevation={0} className="board-empty">
                                <PersonIcon />
                                <Typography>Encara no hi ha anuncis.</Typography>
                            </Paper>
                        )}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};
